<section id="schedule" class="component component--schedule schedule expanded" [ngClass]="filterButton ?'is-filtering':''" [class.page-loading]='defaultButton' *ngIf="!error_message_show">
	<div id="breadcrumb" class="breadcrumb bg-color-white text-color-dark">
		<div class="wrapper">
			<div class="breadcrumb__text">
				<strong class="home-page"><a href="./">WWW</a> / </strong>
				<!-- <a class="current-page" href="{{ breadCrumbData.parent_slug }}" *ngIf="breadCrumbData?.current_page?.title != breadCrumbData.parent">{{ breadCrumbData.parent }} {{ breadCrumbChildLength > 1 ? '/' : ''}} </a> -->
				<span class="current-page" [attr.data-id]="breadCrumbData.parent_id" [attr.data-slug]="breadCrumbData.parent_slug">{{ breadCrumbData.parent }} {{ breadCrumbChildLength > 1 ? '/' : ''}} </span>

				<div ngbDropdown class="d-inline-block">
					<button class="btn btn-outline-primary" id="breadcrumbDropdown" ngbDropdownToggle *ngIf="breadCrumbData?.current_page?.title != ''">{{ breadCrumbData?.current_page?.title }} <span><i class="icon-breadcrumb-bottom"></i></span></button>

					<div ngbDropdownMenu aria-labelledby="breadcrumbDropdown" *ngIf="breadCrumbData?.children != ''">
						<button ngbDropdownItem *ngFor="let bcVal of breadCrumbData?.children" class="{{ breadCrumbData?.current_page?.link == bcVal.link ? 'dropdown-item active-menu' : 'dropdown-item' }}">
							<a routerLink="/{{ bcVal.link }}" (click)="addMenuId( bcVal.id )" [innerHtml]="bcVal.title"></a>
						</button>
					</div>
				</div>
			</div>
			<div class="filter-{{content_type}}">
				<div class="schedule__controller">
					<div class="d-flex justify-space-between">
						<div class="schedule__view-actions d-flex"  *ngIf="content_type == 'Event' || content_type == 'event'">
							<ul class="d-flex">
								<li *ngIf="!this.isMobile">
									<label for="">Showing:</label>
									<button type="button" (click)='status=!status' class="btn btn-prmary extendview">
										<span class="extended-view" (click)="changeView( $event, 'extended', 'schedule__view--activated' )" id="list-view-extended">Reduced view</span>
										<span class="reduced-view" (click)="changeView( $event, 'reduced', 'schedule__view--activated' )" id="list-view-reduced">Extended view</span>
									</button>
									<span class="vertical_bar"></span>
								</li>
								<li class="navigation__search ">
									<div class="btn-group btn-group--days menu-wrapper" ngbDropdown role="group" #weekDrop="ngbDropdown" (click)="getProgramYear();">
										<input type="hidden" id="closeWeeks" (click)="weekDrop.close();">
										<button type="button" class="btn btn-primary dropdown-toggle daysbutton menu-handler" data-toggle="dropdown" id="tagsByDate" ngbDropdownToggle>
											<span class="icon-search-wrapper"><i class="icon-search"></i></span><b>Search</b><b>Close</b>
										</button>

										<div ngbDropdownMenu class="dropdown-menu navigation__sub" aria-labelledby="tagsByDate">
											<div class="wrapper">
												<form class="d-flex ng-pristine ng-invalid ng-touched" (keydown.enter)="$event.preventDefault()">
													<div class="form-group col">
														<b class="search-icon-btn"></b>
														<input autocomplete="off" class="form-control ng-pristine ng-invalid ng-touched" formcontrolname="SearchScheduleText" id="SearchScheduleText" required type="text" value="{{searchText}}" (keydown)="enterSearch( $event, $event.target.value )">

														<input type="hidden" id="hidden-search-text" value="{{ searchText }}">
														<div autoclose="outside" class="search-over__filter" ngbDropdown #yaerDrop="ngbDropdown">
															<input type="hidden" id="closeYear" (click)="yaerDrop.close();">
															<a aria-haspopup="true" class="btn btn-large btn-circle btn-default btn-search-cat dropdown-toggle" id="current-search-option" ngbDropdownToggle aria-expanded="false">
																<b>{{ selectedYear }}</b><span><i class="icon-breadcrumb-bottom"></i></span>
															</a>
															<div class="dropdown-menu" ngbDropdownMenu x-placement="bottom">
																<ul ngbdropdownmenu>
																	<li *ngFor="let year of scheduleYear">
																		<a href="javascript:void(0);" data-slug="all" data-id="{{ year.id }}" (click)="filterMore( $event, 'year', year.id, year.code )">{{ year.code }}</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
													<button class="btn btn-primary btn-circle" type="button" (click)="filterMore( $event, 'text' )" id="programmeSearchButton">
														<span>Search</span><i class="icon-arrow-right"></i>
													</button>
												</form>
											</div>
										</div>
									</div>
								</li>
								<li>
									<div class="btn-group btn-group--tags menu-wrapper" ngbDropdown role="group" #tagDrop="ngbDropdown" (click)="getProgramTags();">
										<input type="hidden" id="closeTags" (click)="tagDrop.close();">
										<input type="hidden" id="open-close-tags" value="{{show_tags}}">
										<button type="button" class="btn btn-primary dropdown-toggle tags-button menu-handler" data-isclicked="0" data-toggle="dropdown" id="topTags" ngbDropdownToggle>
											<b>Tags</b><b>Close</b> <span class="arrow arrow--down"><i class="icon-arrow-down"></i></span><span class="loading__circle loading__circle-extrasmall hide" id="tagloading1"></span>
										</button>

										<ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="topTags" *ngIf="scheduleTags != '' || scheduleSessions != ''">
											<li class="wrapper">
												<ul class="tags-wrapper top-tags">
													<li class="alltags">
														<a href="javascript:void(0);" class="tag-filter tag-list-0" [class.activated] = "tagsAll == true" data-tag="AllTags" (click)="filterMore( $event, 'tags', 0, 'all' ); tagDrop.close();">All Tags</a>
													</li>
													<li *ngFor="let tVal of scheduleTags" class="{{ tVal.enabled == false ? 'disabled': ''}}">
														<a href="javascript:void(0);" class="tag-filter tag-list-{{ tVal.id }} {{ tVal.selected == true && tVal.enabled == true ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', tVal.id, tVal.name ); tagDrop.close();">{{ tVal.name }}</a>
													</li>
													<li class="goldstandard">
														<a href="javascript:void(0);" class="tag-filter gold-btn {{showSelectedgold == true ? 'activated' : ''}}" (click)="filterMore( $event, 'tags', 5000, 'goldstandard' ); tagDrop.close();"><i class="icon-star"></i> goldstandard</a>
													</li>
													<li class="tag-open-sessions">
														<a href="javascript:void(0);" class="tag-filter btn-open-session {{showOpensession == true ? 'activated' : ''}}" (click)="filterMore( $event, 'tags', 25000, 'opensession' ); tagDrop.close();"><i class="icon-open-session"></i> Open Session</a>
													</li>
												</ul>

												<ul class="tags-wrapper free-wrapper tags-event-type" *ngIf="scheduleSessions != ''">
													<li class="alleventypes ">
														<a class="filter-options event-type__filter alltypes session-list-0" [class.activated] = "sessionAll == true" href="javascript:void(0);" data-eventtype="AllSessions" (click)="filterMore( $event, 'session', 0, 'all' ); tagDrop.close();">All sessions</a>
													</li>
													<li *ngFor="let sVal of scheduleSessions" class="{{ sVal.enabled == false ? 'disabled': ''}}">
														<a href="javascript:void(0);" class="filter-options event-type__filter session-list-{{ sVal.id }} {{ sVal.selected == true && sVal.enabled == true ? 'activated' : '' }}" (click)="filterMore( $event, 'session', sVal.id, sVal.name ); tagDrop.close();">#{{ sVal.name }}</a>
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>


			</div>
		</div>

		<div class="selected__wrapper schedule-list-view" id="selectedTags" *ngIf="( content_type == 'Event' || content_type == 'event') && (showSelectedTagsText == true || showSelecteddays == true || showSearchDiv == true )">
				<div class="wrapper">
					<div class="tag-select-wrapper" *ngIf="showSelectedtags == true || showSelectedgold == true || showOpensession == true">
						<span class="tag-title tagblock" *ngIf="showSelectedTagsText == true">Selected tag(s): </span>
						<div class="tags selected__tags tagblock">
							<span class="tagFilter btn" *ngFor="let ctVal of tag_list_name;let i = index" id="tag-{{ tag_list_id[ i ] }}">
								{{ ctVal }}
								<a href="javascript:void(0);" (click)="removeFilter( $event, 'tags', tag_list_id[ i ], ctVal )" class="close-tags"><i class="icon-plus-heart"></i></a>
							</span>
						</div>
					</div>

					<!-- <div class="tag-select-wrapper" *ngIf="showSelecteddays == true">
						<span class="tag-title dayblock">Selected Day(s): </span>
						<div class="tags selected__days dayblock" >
							<span class="tagFilter btn">
								{{ week_day_name }}
								<a href="javascript:void(0);" (click)="removeFilter( $event, 'weekday', week_day_id, week_day_name )" class="close-tags"><i class="icon-plus-heart"></i></a>
							</span>
						</div>
					</div> -->

					<div class="search-tag" style="display: flex; flex-wrap: wrap; align-items: center;" *ngIf="showSearchDiv == true">
						<span style="color: #000;" class="">{{ searchCount }} hits on <em>{{ searchText }}</em> found in</span>
					 	<span style="width: auto;" class="wrapper schedule-list-view">
							<div ngbDropdown class="d-inline-block search-over__filter" #searchOptionDrop="ngbDropdown">
								<input type="hidden" id="closeSearchOption" (click)="searchOptionDrop.close();">
								<button class="btn btn-primary btn-outline-primary btn-circle" ngbDropdownToggle id="breadcrumbDropdown"><b>{{ scheduleSearchOption }}</b><span><i class="icon-breadcrumb-bottom"></i></span></button>
								<div class="search-over__filter-fields" ngbDropdownMenu aria-labelledby="breadcrumbDropdown">
									<ul>
										<li>
											<a href="javascript:void(0);" (click)="filterMore( $event, 'search_option', 'All', 'All' )" [class.current]="scheduleSearchOption == 'All'" >All</a>
										</li>

										<li>
											<a href="javascript:void(0);" (click)="filterMore( $event, 'search_option', 'Title', 'Title' )" [class.current]="scheduleSearchOption == 'Title'">Title</a>
										</li>

										<li>
											<a href="javascript:void(0);" (click)="filterMore( $event, 'search_option', 'Convenor', 'Convenor' )" [class.current]="scheduleSearchOption == 'Convenor'">Convenor</a>
										</li>

										<li>
											<a href="javascript:void(0);" (click)="filterMore( $event, 'search_option', 'Description', 'Description' )" [class.current]="scheduleSearchOption == 'Description'">Description</a>
										</li>

										<li>
											<a href="javascript:void(0);" (click)="filterMore( $event, 'search_option', 'Speakers', 'Speakers' )" [class.current]="scheduleSearchOption == 'Speakers'">Speakers</a>
										</li>
									</ul>
								</div>
							</div>
						</span>
					</div>
				</div>
			</div>
		</div>

	<div class="bg-color-grey" *ngIf="( content_type  == 'Event' || content_type == 'event' ) && !this.isMobile">
		<div class="wrapper">
			<ul class="tags-wrapper free-wrapper tags-day-type">
				<li class="allDaystag">
					<a class="filter-options dayFilter weekday-list-0  {{ week_day_id == 0 ? 'activated' : '' }}" id="allDays" href="javascript:void(0);" (click)="filterMore( $event, 'weekday', 0, 'all' )">All days</a>
				</li>
				<li *ngFor="let day of newDaysArr">
					<a href="javascript:void(0);" class="filter-options dayFilter {{ currentDay == day.date ? 'activated' : ''}}" (click)="filterMore( $event, 'weekday', day.date, day.dayName )">{{day.dayName}}</a>
				</li>
			</ul>
		</div>
	</div>

	<div class="filterButton__wrapper" *ngIf="filterButton">
		<span class="filterButton">
			<span class="loading__circle loading__circle-small" id="fitlerLoader"></span>
		</span>
	</div>

	<div class="text-center load-more link-wrapper modify-seemore wrapper" *ngIf="show_all_events_button && 'exhibition' !== content_type && !this.isMobile">
		<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="showAllEvents();"><b>See previous events</b></a>
	</div>

	<div class="schedule__events schedule__events-list-view schedule__events-extended-view" id="schedule__events" [ngClass]="(showSelectedtags == true && showSearchDiv == true ) || (showSelectedgold == true && showSearchDiv == true ) || (showOpensession == true && showSearchDiv == true )  ? 'morePadding2' : showSelectedtags == true || showSelectedgold == true || showOpensession == true || showSearchDiv == true ? 'morePadding' : ''">
  <div class="events__date date-dropdown-toggle" *ngIf="this.isMobile && ( content_type  == 'Event' || content_type == 'event' ) && dateTimeArray != ''" >
    <div ngbDropdown class="d-inline-block" #dateDDL="ngbDropdown">
      <button class="btn btn-outline-primary" id="dateDropdown" ngbDropdownToggle (click)="timeDDL.close"><h2>{{ activeDate | date:'EEEE dd LLLL' }}</h2> <span><i class="icon-breadcrumb-bottom"></i></span></button>

      <div ngbDropdownMenu aria-labelledby="dateDropdown">
        <div ngbDropdownItem *ngFor="let value of dateTimeArray;index as i;last as isLast" [ngClass]="activeDate == value.date ? 'current-date' : ''">
          <a href="javascript:void(0);" id="date-{{ i }}" (click)="getDatabyDateTime( 'date', i, value.date, isLast ); dateDDL.close();" class="{{ value.date }}" [ngClass]="isLast ? 'last-date' : ''">{{ value.date | date:'EEEE dd LLLL' }}</a>
        </div>
      </div>
    </div>

    <div ngbDropdown class="d-inline-block" #timeDDL="ngbDropdown">
      <button class="btn btn-outline-primary" id="timeDropdown" ngbDropdownToggle (click)="dateDDL.close"><h4><em class="separatorbar">|</em> <span>{{ activeTime }}</span></h4> <span><i class="icon-breadcrumb-bottom"></i></span></button>

      <div ngbDropdownMenu aria-labelledby="timeDropdown" *ngIf="dateTimeArray != '' && false == is_conference">
        <div *ngFor="let time of dateTimeArray;index as i;first as isFirst" class="time-{{i}} timediv" [ngClass]="isFirst ? 'show' : 'hide'">
          <div ngbDropdownItem *ngFor="let val of time.values[0].time">
            <a href="javascript:void(0);" (click)="getDatabyDateTime( 'time', val ); timeDDL.close();" [ngClass]="activeTime == val ? 'current-time' : '' ">{{ val }}</a>
          </div>
        </div>
      </div>
      <div ngbDropdownMenu aria-labelledby="timeDropdown" *ngIf="dateTimeArray != '' && true == is_conference">
        <div *ngFor="let time of dateTimeArray;index as i;first as isFirst" class="time-{{i}} timediv" [ngClass]="time.date == activeDate ? 'show' : 'hide'">
          <div ngbDropdownItem *ngFor="let val of time.values[0].time">
            <a href="javascript:void(0);" (click)="getDatabyDateTime( 'time', val ); timeDDL.close();" [ngClass]="activeTime == val ? 'current-time' : '' ">{{ val }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

	<div id="time-zone" class="time-zone__visible">
		<div class="time-zone__fix-later">
			<div class="wrapper wrapper-sh">
				<div class="events" *ngFor="let sVal of scheduleDotNetData; first as isFirst">
					<div class="events__date sticky__date" id="laterFixed" *ngIf="isFirst">
						<div class="sticky-wrapper">
							<div class="wrapper__inner">
								<h2 class="sticky_datesschedule" [innerHtml]="sVal.day"></h2>
								<h4 x-ms-format-detection="none"> | {{ sVal.time }}</h4>
								<span class="datesschedule-witharrow"><i class="icon-breadcrumb-bottom"></i></span>
							</div>
							<div class="focus_area" *ngIf="sVal.focus_area && 'null' != sVal.focus_area && '' != sVal.focus_area" [innerHtml]="sVal.focus_area"></div>
						</div>
					</div>

				</div>
				<div class="sticky-time-zone" [ngClass]="showTimezone?'time-zone-shown':'time-zone-hidden'" *ngIf="scheduleDotNetData != ''">
					<ngx-select
					[items]="timeZones"
					[placeholder]="selectedTimezone"
					(select)="filterMore( $event, 'timezone' )"
					[defaultValue]="selectedTimezone"
					[keepSelectedItems]="true"
					></ngx-select>
				</div>
			</div>
		</div>
		<div class="events time-zone__show-later" *ngFor="let sVal of scheduleDotNetData; first as isFirst">
			<div class="events__date sticky__date" id="laterFixed" *ngIf="isFirst">
					<div class="sticky-wrapper">
						<div class="wrapper__inner">
							<h2 class="sticky_datesschedule" [innerHtml]="sVal.day"></h2>
							<h4 x-ms-format-detection="none"> | {{ sVal.time }}</h4>
							<span class="datesschedule-witharrow"><i class="icon-breadcrumb-bottom"></i></span>
						</div>
						<div class="focus_area" *ngIf="sVal.focus_area && 'null' != sVal.focus_area && '' != sVal.focus_area" [innerHtml]="sVal.focus_area"></div>
				</div>
			</div>
		</div>
	</div>
		<div class="events {{sVal.eventSeparatorClass}}" *ngFor="let sVal of scheduleDotNetData; last as isLast; first as isFirst;">
			<div class="events__date sticky__date" *ngIf="!isFirst">
				<div class="wrapper">
					<div class="sticky-wrapper">
						<div class="wrapper__inner">
							<h2 class="sticky_datesschedule" [innerHtml]="sVal.day"></h2>
							<h4 x-ms-format-detection="none"> | {{ sVal.time }}</h4>
							<span class="datesschedule-witharrow"><i class="icon-breadcrumb-bottom"></i></span>
						</div>
						<div class="focus_area" *ngIf="sVal.focus_area && 'null' != sVal.focus_area && '' != sVal.focus_area" [innerHtml]="sVal.focus_area"></div>
					</div>
				</div>
			</div>

			<div class="events__details">
				<div class="events__wrapper">
					<div class="grid-sizer"></div>
					<div class="items events__repeater" *ngFor="let sdVal of sVal.values" id="{{sdVal.val.id}}">
						<div class="wrapper">
							<div class="events__list">
								<!-- <div class="events__message">
									<a *ngIf="shareddata.loggedIn == true && shareddata.is_community_user == 'true'" class="like-button" [class.btn-favorited] = "sdVal.val.favouriteId != 0" (click)="saveFavourite( sdVal.val.id, sdVal.val.favouriteId );"><i class="icon-heart"></i></a>

									<span class="like-button__wrapper" ngbDropdown autoClose="outside" placement="bottom-right" *ngIf="shareddata.loggedIn == true && shareddata.is_community_user == 'false'">
										<a href="javascript:;" ngbDropdownToggle class="like-button"><i class="icon-heart"></i></a>
										<span ngbDropdownMenu>You are not community member – and therefore have limited accessibility – <a href="https://b-com.mci-group.com/EventPortal/Information/190801WWW/WELCOME.aspx" target="_blank">Register</a> today to get full access!</span>
									</span>

									<span class="like-button__wrapper" ngbDropdown autoClose="outside" placement="bottom-right" *ngIf="shareddata.loggedIn == false">
										<a href="javascript:;" ngbDropdownToggle class="like-button"><i class="icon-heart"></i></a>
										<span ngbDropdownMenu>You are not logged in, and cannot add favourites <a href="javascript:;" (click)="goToLoginPage()">login</a></span>
									</span>
								</div> -->

								<div class="events__image">
									<a class="events__link" routerLink="/event/{{sdVal.val.slug}}" attr.data-slug="{{sdVal.val.slug}}">
										<div class="">
											<figure *ngIf="this.isMobile">
												<img src="{{sdVal.val.imageMobile}}" class="img-responsive" alt="&nbsp;" />
												<span></span>
											</figure>
											<figure *ngIf="!this.isMobile">
												<img src="{{sdVal.val.image}}" class="img-responsive" alt="&nbsp;" />
												<span></span>
											</figure>
										</div>

										<div class="orgbefore org">
											<span *ngFor="let cVal of sdVal.val.Convenors;last as isLast">{{ cVal.name }} <b>{{ isLast ? '' : '| ' }}</b></span>
										</div>
									</a>
								</div>

								<div class="events__text">
									<div class="events__text-wrapper {{ ( sdVal.val.hasConclusion == true ) ? 'events__concluded' : '' }} events__link">
										<div class="maxed-width">
											<a class="{{ ( sdVal.val.hasConclusion == true ) ? 'events__concluded' : '' }} events__link" routerLink="/event/{{sdVal.val.slug}}" attr.data-slug="{{sdVal.val.slug}}">
												<span class="label label-primary" *ngIf="sdVal.val.hasConclusion == true">
													<i class="icon-conclusion"></i>
												</span>
												<div class="event_status">
													<span class="icon-wrapper">
														<span *ngIf="'online' == sdVal.val.online"><span class="icon icon-cloud"></span>Online session</span>
														<span *ngIf="'on-site' == sdVal.val.online"><span class="icon icon-map-pin"></span>On-site session</span>
														<span *ngIf="'both' == sdVal.val.online"><span class="icon icon-cloud"></span><span class="icon icon-map-pin"></span>Online & On-site session</span>
													</span>
													<span class="within-circle icon icon-map-pin" *ngIf="null != sdVal.val.room"></span><span [innerHtml]="sdVal.val.room"></span>
												</div>
												<h3 *ngIf="showSearchDiv == true" [innerHtml]="highlight_search_text( sdVal.val.title )"></h3>
												<h3 *ngIf="showSearchDiv == false" [innerHtml]="sdVal.val.title"></h3>

												<div class="orgafter org">
													<span *ngFor="let cVal of sdVal.val.Convenors;last as isLast">{{ cVal.name }} <b>{{ isLast ? '' : '| ' }}</b> </span>
												</div>

												<div class="events__short-info" *ngIf="sdVal.val.description != ''">
													<div [innerHtml]="sdVal.val.description | safe:'preamble'"><br><br></div>
												</div>

												<div class="events__short-info events__short-intro" *ngIf="sdVal.val.introduction != '' &&  showSearchDiv == false && ( (content_type  == 'Event' || content_type == 'event' && !this.isMobile ) || ( content_type == 'Exhibition' || content_type == 'exhibition') )">
													<div [innerHtml]="sdVal.val.introduction | safe:'preamble'"></div>
												</div>
												<div class="events__short-info events__short-intro" *ngIf="sdVal.val.introduction != '' &&  showSearchDiv == true && ( (content_type  == 'Event' || content_type == 'event' && !this.isMobile ) || ( content_type == 'Exhibition' || content_type == 'exhibition') )">
													<div [innerHtml]="highlight_search_text( sdVal.val.introduction ) | safe:'preamble'"></div>
												</div>
											</a>
											<div class="events__convenor-organisation" *ngIf="( (content_type  == 'Event' || content_type == 'event' && !this.isMobile ) || ( content_type == 'Exhibition' || content_type == 'exhibition') )">
												<div class="schedule-detail__org small-fonts" *ngIf="sdVal.val.convenors">
													<div class="d-flex">
														<div class="left-convenor">
															<span *ngFor="let cVal of sdVal.lConvenor;last as isLast" [innerHtml]="cVal.name"> </span>
														</div>
														<div class="right-convenor">
															<span *ngFor="let cVal of sdVal.rConvenor;last as isLast" [innerHtml]="cVal.name"> </span>
														</div>
													</div>
												</div>
											</div>
											<!-- {{sdVal.val.otherConvenor}} -->

											<div class="events__mobile-info">
												<span class="icon_wrapper"><i class="icon-clock"></i></span><span class="val">{{ sVal.time }}</span> <span class="icon_wrapper" *ngIf="sdVal.val.room"><i class="icon-map-pin"></i></span><span class="val" *ngIf="sdVal.val.room" [innerHtml]="sdVal.val.room"></span>
											</div>

											<ul class="tags tags-schedule" *ngIf="!this.isMobile">
												<li class="btn btn-default tag-list-{{ tagVal.id }} {{ tagVal.selected == true ? 'activated' : ''}}" *ngFor="let tagVal of sdVal.val.tags" (click)="filterMore( $event, 'tags', tagVal.id, tagVal.name )" attr.data-tag="{{ tagVal.id }}">{{ tagVal.name }}</li>
												<li class="btn btn-default session-event {{ showSelectedsession == true ? 'activated' : '' }}" *ngIf="sdVal?.val?.eventType" (click)="filterMore( $event, 'session', sdVal.val.eventTypeId, sdVal.val.eventType )">#{{ sdVal.val.eventType }}</li>
												<li class="btn btn-default gold-btn {{ showSelectedgold == true ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 5000, 'goldstandard' )" *ngIf="sdVal.val.isGoldStar == true"><i class="icon-star"></i> goldstandard</li>
												<li class="btn btn-default btn-open-session {{ showOpensession == true ? 'activated' : '' }}" (click)="filterMore( $event, 'tags', 25000, 'opensession' )" *ngIf="sdVal.val.isOpenSession == true"><i class="icon-open-session"></i> Open Session</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<input type="hidden" id="hiddenlasttime" value="{{lastInterval}}">
	</div>

	<div class="text-center load-more link-wrapper" *ngIf="scheduleDotNetData != '' && !loadMoreButton && showMoreButton && !defaultButton && !this.isMobile">
		<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreScheduleList()" id="show-more-button"><b>Show More</b> <span><i class="icon-breadcrumb-bottom"></i></span></a>
	</div>

	<div class="text-center load-more link-wrapper" *ngIf="!loadMoreButton && showMoreButton && !defaultButton  && filterCount != 0 && this.isMobile">
		<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="loadMoreScheduleList()" id="show-more-button"><b>Show More</b> <span><i class="icon-breadcrumb-bottom"></i></span></a>
	</div>

	<div class="text-center load-more link-wrapper" *ngIf="this.isMobile && ( content_type  == 'Event' || content_type == 'event' ) && !isLastDate && filterCount == 0">
		<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" (click)="loadNextDayScheduleList()" id="show-more-button"><b>Load Next Day</b> <span><i class="icon-breadcrumb-bottom"></i></span></a>
	</div>

	<div class="text-center load-more link-wrapper" *ngIf="loadMoreButton">
		<span><span class="loading__circle loading__circle-small"></span></span>
	</div>
</section>

<div class="alert-login error-message" id="error-message" *ngIf="error_message_show">
	<div class="wrapper">
		<span><p [innerHtml]="error_message"></p></span>
	</div>
</div>
